import { useState, useEffect } from 'react'
import './assets/css/style.css'
import Header from './components/Header';
import Footer from './components/Footer';
import AppRouter from './components/AppRouter';
import { BrowserRouter } from 'react-router-dom';
import { AuthContext } from './context';

function App() {
  const [isAuthStudent, setIsAuthStudent] = useState(false);
  const [isAuthAdmin, setIsAuthAdmin] = useState(false);
  const [studentId, setStudentId] = useState(null)
  const [isLoading, setLoading] = useState(true)
  const [accessToken, setAccessToken] = useState(null)
  const [employeeId, setEmployeeId] = useState(null)
  const [roleName, setRoleName] = useState(null)

  useEffect(() => {
    document.title = "Анкетирование ДГУ"
    if (sessionStorage.getItem('isAuthStudent')) {
      setIsAuthStudent(true)
      setStudentId(sessionStorage.getItem('studentId'))  
    } 

    if (sessionStorage.getItem('isAuthAdmin')) {
      setIsAuthAdmin(true)
      setAccessToken(sessionStorage.getItem('access_token'))
      setEmployeeId(sessionStorage.getItem("employeeId"))
      setRoleName(sessionStorage.getItem("roleName"))
    }

    setLoading(false)
  }, [])

  return (
    !isLoading &&
    <AuthContext.Provider value={{
      isAuthStudent,
      setIsAuthStudent,
      isAuthAdmin,
      setIsAuthAdmin,
      studentId,
      setStudentId,
      accessToken,
      setAccessToken,
      employeeId,
      setEmployeeId,
      roleName,
      setRoleName
    }}>
    <BrowserRouter>
      <div className='site-wrapper'>
        <Header />
        <main>
          <AppRouter />   
        </main>
        <Footer />
      </div>
    </BrowserRouter>
    </AuthContext.Provider>
  );
}

export default App;